// generated by the plop

import { PROGRESS_STATUSES } from 'symbols';
import { ClientModel, StoryModel } from '../../symbols';

export interface ClientStateModel {
  clientList: ClientModel[],
  loadClientListStatus: PROGRESS_STATUSES,
  currentClientStory: StoryModel,
  loadStoryStatus: PROGRESS_STATUSES,
  currentClientInfo?: ClientModel
}

export const CLIENT_STATE_DEFAULT: ClientStateModel = {
  clientList: [],
  loadClientListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  currentClientStory: null,
  loadStoryStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  currentClientInfo: null
};
